module.exports = __webpack_public_path__ + "img/alumni-bg.73e0619d.jpg";